import React from 'react'
import Navbar from './components/Navbar'
import Blog from './components/Blog'

export default function App() {
  return (
    <div>
      <Navbar/>
      <Blog/>
    </div>
  )
}
